<navigation-dropdown
  [isNavigationDropdownButtonClassNeeded]="!withoutBorderOnFocus"
  [menuItems]="appsMenuItems"
  [dropdownTitle]="'open_dropdown_content' | localize"
  (dropdownToggled)="onDropdownToggled($event)"
  dropdownMenuClass="ml-8px"
  placement="topRight">
  <i class="icon" [class.navigation-dropdown-icon-v2]="withoutBorderOnFocus" [uiType]="iconType" ui-icon gh-dropdown-toggle></i>
</navigation-dropdown>
